import React, { useState } from 'react';
import { Container, ThisCard } from './styles';

import LogoClienteAtivo from '~/assets/icones/LogoClienteAtivo.svg';
import LogoClienteAtivoB from '~/assets/icones/LogoClienteAtivoB.svg';

function CustomBodyContent({ data }) {
  const [linhaAtiva, setLinhaAtiva] = useState([]);

  return (
    <Container>
      {data?.map((thisData, i) => (
        <ThisCard
          className={
            linhaAtiva === thisData?.id ? 'card-item ativo' : 'card-item'
          }
          {...{ data: thisData, linhaAtiva, setLinhaAtiva }}
          key={thisData?.id || i}
          id={thisData?.id || i}
          index={i}
          ativo={linhaAtiva === thisData?.id ? true : false}
        >
           <div className="card-body">
            <div className="card-text">
              <p className="descricao">#{thisData?.codigo}</p>
              <p className="titulo">{thisData?.nome}</p>
            </div>
          </div>
          <div className="card">
            <img src={localStorage.getItem("tema") == "E" ? LogoClienteAtivo : LogoClienteAtivoB} alt="Vazio" />
          </div>
        </ThisCard>
      ))}
    </Container>
  );
}

export default CustomBodyContent;
